import * as React from "react";
import { MemoriaBase } from "./MemoriaBase";
import { NFCE_CONFIG } from "./memoriaConfigs";

export const MemoriaNfce = () => <MemoriaBase config={NFCE_CONFIG} />;

export default MemoriaNfce;
